"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentSize = void 0;
var React = __importStar(require("react"));
function useComponentSize() {
    var _a = React.useState({
        height: 0,
        width: 0,
    }), size = _a[0], setSize = _a[1];
    var ref = React.useRef();
    var onResize = React.useCallback(function () {
        if (!ref.current) {
            return;
        }
        var newHeight = ref.current.offsetHeight;
        var newWidth = ref.current.offsetWidth;
        if (newHeight !== size.height || newWidth !== size.width) {
            setSize({
                height: newHeight,
                width: newWidth,
            });
        }
    }, [size.height, size.width]);
    React.useLayoutEffect(function () {
        if (!ref || !ref.current) {
            return;
        }
        var resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(ref.current);
        return function () { return resizeObserver.disconnect(); };
    }, [ref, onResize]);
    return __assign({ ref: ref }, size);
}
exports.useComponentSize = useComponentSize;
//# sourceMappingURL=useComponentSize.js.map